import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ContactFilterService } from '../../shared/services/contact-filter.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { FilterAssist } from '../../../models/filter-assist';
import { contactsTableAddAssist, contactsTableRemoveAssist } from '../../../store/contacts-table/contacts-table.actions';
import { selectContactsTableQuery } from '../../../store/contacts-table/contacts-table.state';
import { Observable } from 'rxjs';
import { ContactsQuery } from '../../../models/contacts-query';
import { debounceTime, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-contact-table-filter',
    templateUrl: './contact-table-filter.component.html',
    styleUrls: ['./contact-table-filter.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, IconComponent, MatInput, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class ContactTableFilterComponent implements OnInit {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    public categoryCard = FilterCategoryEnum.CARD;
    public categoryCountry = FilterCategoryEnum.COUNTRY;
    public categoryAddressBook = FilterCategoryEnum.ADDRESS_BOOK;

    constructor(private contactFilterService: ContactFilterService, private store: Store<AppState>) {
    }

    searchForm = new UntypedFormGroup({
        terms: new UntypedFormControl('')
    });

    contactsQuery$: Observable<ContactsQuery> = this.store.select(selectContactsTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.contactsQuery$.pipe(
        switchMap((query) => this.contactFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        debounceTime(200),
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        mergeMap(terms => this.contactFilterService.autocompleteTerms(terms))
    );

    ngOnInit(): void {
    }

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(contactsTableAddAssist({ id: assist.id, parameter: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(contactsTableRemoveAssist({ id }));
    }

}
